import { FC } from "react";
import { useNavigate } from "react-router-dom";

import { IModalProps } from "config/init/providers/ModalsProvider";
import { usePop } from "containers/DynamicForm/useButtonCommand/usePop";
import { Layout, useTranslation } from "modules";

const DocumentUploadErrorModal: FC<IModalProps> = ({ closeModal }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const popCommand = usePop();

  const onCloseHandler = async () => {
    try {
      closeModal();
      await popCommand([], {});
    } catch (error) {
      navigate(-1);
    }
  };

  const content = {
    alwaysShowIcon: true,
    button: [
      {
        text: t("document_upload_error.modal.cta", "CONTACT SUPPORT"),
        onClick: () => navigate("/customer-support"),
      },
    ],
    icon: "BlobTurtleError",
    header: t("document_upload_error.modal.header", "Upload failed"),
    onClose: onCloseHandler,
    subheader: t(
      "document_upload_error.modal.subheader",
      "Sorry, something went wrong as we tried to upload your documents. Please contact our support team and they will help resolve the issue. Thanks."
    ),
  };

  return <Layout as="ModalLayout" className="left-align-sm" content={content} />;
};

export default DocumentUploadErrorModal;
